import {api, ReactQueryOptions} from './utils/api';

type UsePoliciesOptions = {
    includePending?: boolean;
    useDdb?: boolean;
} & ReactQueryOptions['policies']['list'];

export function usePolicies(options?: UsePoliciesOptions) {
    const result = api.policies.list.useQuery({useDdb: options?.useDdb}, options);

    const {data, ...query} = result;

    const policies = data?.filter(
        (p: any) => p.requirements.length || (options?.includePending && p.status === 'pending_update'),
    );

    return {
        data: policies,
        ...query,
    };
}

type UsePolicyOptions = ReactQueryOptions['policies']['get'] & {poll?: boolean};

export function usePolicy({id}: {id: string}, options: UsePolicyOptions = {}) {
    const {data: application} = api.instantIul.application.useQuery(undefined);
    const resp = api.policies.get.useQuery(
        {id},
        {
            ...options,
            refetchInterval: (data) => {
                if ((!data && application) || data?.status === 'pending_update') return 500;
                return false;
            },
        },
    );

    const requirementsWithJsonParsed = resp.data?.requirements.map((r: any) => ({
        ...r,
        dataJson: typeof r.dataJson === 'string' ? JSON.parse(r.dataJson || '{}') : r.dataJson,
    }));

    return {
        ...resp,
        data: {
            ...resp.data,
            requirements: requirementsWithJsonParsed,
        },
    };
}
